import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/pick_place_sheet/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'drag', sortable: false, filterable: true, divider: false, brief: true, width: 30},
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: false, width: 20},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: false, width: 20},
        {text: '', value: 'manager', sortable: false, filterable: true, divider: false, brief: true, width: 30},
        {text: '', value: 'task_status', sortable: false, filterable: true, divider: false, brief: true, width: 50},
        // {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        // {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        // {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        PickPlaceSheetTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}